import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CurrentPostureCounts } from 'projects/oct-report-lib/src/public-api';

const headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Access-Control-Allow-Origin': '*',
};

@Injectable()
export class SwayBaselineCurrentPostureCountDataService extends DefaultDataService<any> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
        super('BaselineCurrentPostureCount', http, httpUrlGenerator);
    }

    override getWithQuery(params: { msp: string; tenant: string }): Observable<CurrentPostureCounts[]> {
        return this.http
            .get<CurrentPostureCounts>(`/api/report/tenant/${params.tenant}/baselines/posture/count`, {
                headers: {
                    ...headers,
                    'msp-id': params.msp,
                    'tenant-id': params.tenant,
                },
            })
            .pipe(
                map((res) => [res]),
                catchError((err) => {
                    console.log('[error] SwayBaselineCurrentPostureCountDataService:', JSON.stringify(err));
                    return of(err);
                }),
            );
    }
}
